import React, { useState } from "react";
import { Form, Button, Container } from "react-bootstrap";
import "../App.css";
import { handlSignin } from "../API/AuthService";
import { toast } from "react-toastify";

const SignInForm = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleSignIn = async(e) => {
    e.preventDefault();
    try{
        const payload = {
            email: username,
            password: password
        }
      const resData = await handlSignin(payload)
      if(resData?.success){
        toast.success('Sigin success')
        localStorage.setItem('Aprofile', JSON.stringify(resData.data))
        window.location.reload()
      }
    }catch(err){
        if(err.response?.data?.message){
            toast.error(err.response.data.message)
        }else{
            toast.error('Something went wrong')
        }
    }
  };

  return (
    <Container>
      <div className="d-flex justify-content-center">
        <Form className="mt-4 signform border p-2" onSubmit={handleSignIn}>
          <Form.Group controlId="formUsername">
            <Form.Label>Username</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Group>
            <Button className="m-2" variant="primary" type="submit">
              Sign In
            </Button>
        </Form>
      </div>
    </Container>
  );
};

export default SignInForm;
